"use strict";
/*
  This file is part of web3x.

  web3x is free software: you can redistribute it and/or modify
  it under the terms of the GNU Lesser General Public License as published by
  the Free Software Foundation, either version 3 of the License, or
  (at your option) any later version.

  web3x is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Lesser General Public License for more details.

  You should have received a copy of the GNU Lesser General Public License
  along with web3x.  If not, see <http://www.gnu.org/licenses/>.
*/

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _1 = require(".");

var utils_1 = require("../../utils");

var ContractAbi = /*#__PURE__*/function () {
  function ContractAbi(definition) {
    _classCallCheck(this, ContractAbi);

    this.functions = definition.filter(function (e) {
      return e.type === 'function';
    }).map(function (entry) {
      return new _1.ContractFunctionEntry(entry);
    });
    this.events = definition.filter(function (e) {
      return e.type === 'event';
    }).map(function (entry) {
      return new _1.ContractEventEntry(entry);
    });
    var ctor = definition.find(function (e) {
      return e.type === 'constructor';
    });
    this.ctor = new _1.ContractFunctionEntry(ctor || {
      type: 'constructor'
    });
    var fallback = definition.find(function (e) {
      return e.type === 'fallback';
    });

    if (fallback) {
      this.fallback = new _1.ContractFunctionEntry(fallback);
    }
  }

  _createClass(ContractAbi, [{
    key: "findEntryForLog",
    value: function findEntryForLog(log) {
      return this.events.find(function (abiDef) {
        return abiDef.signature === log.topics[0];
      });
    }
  }, {
    key: "decodeEvent",
    value: function decodeEvent(log) {
      var event = this.findEntryForLog(log);

      if (!event) {
        throw new Error("Unable to find matching event signature for log: ".concat(log.id));
      }

      return event.decodeEvent(log);
    }
  }, {
    key: "decodeFunctionData",
    value: function decodeFunctionData(data) {
      var funcSig = utils_1.bufferToHex(data.slice(0, 4));
      var func = this.functions.find(function (f) {
        return f.signature === funcSig;
      });
      return func ? func.decodeParameters(data.slice(4)) : undefined;
    }
  }]);

  return ContractAbi;
}();

exports.ContractAbi = ContractAbi;